export default "__VITE_ASSET__By3lAKrR__"